import { yupResolver } from "@hookform/resolvers/yup";
import { Controller, useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import { ThemeProvider } from "styled-components";
import customtheme from "../../../themes";
import { Avatar, Box, Button, Checkbox, Container, FormControlLabel, Grid, IconButton, Paper, TextField, Tooltip, Typography } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import * as yup from 'yup';
import { ContextNotification, severitys } from "../../../App";
import RtlProvider from "../../../Components/RtlProvider";
import helper from "../../../helper";
import passengerApi from "../../../api/passengerApi";
import BeatLoading from "../../../Components/Loader/BeatLoader";
import { RHFRadioGroup } from "../../../Components/RHFRadioGroup";
import { FaUserPlus } from "react-icons/fa";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import DatePicker from "react-multi-date-picker";
import CustomDateInput from "../../../Components/CustomDateInput";
import { RHFAutocomplete } from "../../../Components/RHFAutocomplete";
import staticVariablesApi from "../../../api/staticVariablesApi";
import moment from "jalali-moment";
import DateObject from "react-date-object";
import { MdDelete, MdEditSquare } from "react-icons/md";
import brokerGroupApi from "../../../api/brokerGroupApi";
import { DataGrid } from "@mui/x-data-grid";
import ConfirmationDialog from "../../../Components/ConfirmationDialog";


const AddPassengerToFlight = ({ row, refresh }) => {

    const [isLoading, setIsLoading] = useState(false);
    const { setOpen } = useContext(ContextNotification);
    const [passengers, setPassengers] = useState([]);
    const [selectedPassenger, setSelectedPassenger] = useState(null);
    const [requiredError, setRequiredError] = useState(false);
    const [showAddGuest, setShowAddGuest] = useState(false);
    const [guestType, setGuestType] = useState(null);
    const [flightGuests, setFlightGuests] = useState([]);

    const schema = yup.object().shape({
        ssn: yup.string().trim().max(10, "10 رقم وارد نمایید").trim().required("کد ملی را وارد نمایید")
            .test("SSNValidaton", "کد ملی صحیح نیست", (value) => helper.SSNValidator(value)),
        passNO: yup.string().trim().required("شماره گذرنامه را وارد نمایید").test('len', 'حداکثر 10 کاراکتر', (val) => val.length <= 10),
        name: yup.string().trim().required('نام را وارد نمائید'),
        family: yup.string().trim().required('نام خانوادگی را وارد نمائید'),
        fatherName: yup.string().trim().required('نام پدر را وارد نمائید'),
        birthDate: yup.string().trim().required(' تاریخ تولد را وارد نمائید'),
        guestTypeId: yup.number().required('نوع میهمان را انتخاب نمائید'),
    });
    const { register, handleSubmit, control, formState: { errors }, watch, setValue } = useForm({
        resolver: yupResolver(schema),

    });
    const Columns = [
        { field: "guestTypeTitle", headerName: "نوع میهمان", width: '150' },
        { field: "ssn", headerName: "کد ملی", width: '150' },
        { field: "name", headerName: "نام", width: '100' },
        { field: "family", headerName: "نام خانوادگی", width: '150' },
    ];
    Columns.push({
        field: "ویرایش", renderCell: (cellValues) => {
            return (
                <IconButton
                    disabled={isLoading}
                    sx={{ color: '#4a148c' }}
                    onClick={() => {
                        handleOpenEdit(cellValues.row)
                    }}><MdEditSquare />
                </IconButton>
            )
        }
    });

    Columns.push({
        field: "حذف", renderCell: (cellValues) => {
            return (
                <IconButton
                    disabled={isLoading}
                    sx={{ color: '#c70c05c2' }}
                    onClick={() => {
                        handleOpenDelete(cellValues.row)
                    }}><MdDelete />
                </IconButton>
            )
        }
    });

    useEffect(() => {
        ResetForm();
    }, []);
    useEffect(() => {
        ResetForm();
    }, [row]);

    const onSubmit = (data) => {

        handleAddEditGuest(data);


    }

    const SearchPassenger = () => {

        setPassengers([]);
        setSelectedPassenger(null);
        var Searchssn = null;
        if (watch("Searchssn"))
            Searchssn = watch("Searchssn");
        if (Searchssn?.length > 5) {
            setIsLoading(true)
            passengerApi.SearchPassenger(Searchssn).then(res => {
                if (res.status === 200) {
                    setPassengers(res.data.data.map((itm) => {
                        return {
                            "id": itm.id,
                            "label": itm.name + ' ' + itm.family + '، ' + 'نام پدر ' + itm.fatherName
                        }
                    }));
                }
                else {
                    setOpen({ IsEnable: true, Message: res.data.message ? res.data.message : 'خطا در جستجوی زائر', severity: severitys.error });
                }
            }).catch(err => {

                if (err.status === 401) {
                    localStorage.clear();
                    window.location.pathname = "/login";
                }
                if (err.response && err.response.data) {
                    setOpen({ IsEnable: true, Message: JSON.stringify(err.response.data), severity: severitys.error });
                }
                else if (err.response && err.response.data && err.response.data.errors) {
                    setOpen({ IsEnable: true, Message: JSON.stringify(err.response.data.errors), severity: severitys.error });
                }
                else if (err.message) {
                    setOpen({ IsEnable: true, Message: JSON.stringify(err.message), severity: severitys.error });
                }

            }).finally(() => { setIsLoading(false) });
        }
    }

    const handleChangeRadioGroup = (id) => {

        setSelectedPassenger(id);
    }
    const addPassengerToFlight = (flightId, passengerid) => {
        setIsLoading(true);
        brokerGroupApi.AddPassengerToFlight(flightId, passengerid).then(res => {

            if (res.data?.success) {
                setOpen({ IsEnable: true, Message: 'مسافر به پرواز مورد نظر افزوده شد', severity: severitys.success });

            }
            else {
                setOpen({ IsEnable: true, Message: res.data.message ? res.data.message : 'خطا در عملیات', severity: severitys.error });
            }

        }).catch(err => {

            if (err.response && err.response.data) {
                setOpen({ IsEnable: true, Message: JSON.stringify(err.response.data), severity: severitys.error });
            }
            else if (err.response && err.response.data && err.response.data.errors) {
                setOpen({ IsEnable: true, Message: JSON.stringify(err.response.data.errors), severity: severitys.error });
            }
            else if (err.message) {
                setOpen({ IsEnable: true, Message: JSON.stringify(err.message), severity: severitys.error });
            }

        }).finally(() => {
            setIsLoading(false);
            ResetForm();
        });
    }

    const HandleEditGuestFlight = (guestId, data) => {
        setIsLoading(true);
        brokerGroupApi.EditGuestToFlight(guestId, data).then(res => {

            if (res.data?.success) {
                setOpen({ IsEnable: true, Message: 'مسافر میهمان با موفقیت ویرایش شد', severity: severitys.success });

            }
            else {
                setOpen({ IsEnable: true, Message: res.data.message ? res.data.message : 'خطا در عملیات', severity: severitys.error });
            }

        }).catch(err => {

            if (err.response && err.response.data) {
                setOpen({ IsEnable: true, Message: JSON.stringify(err.response.data), severity: severitys.error });
            }
            else if (err.response && err.response.data && err.response.data.errors) {
                setOpen({ IsEnable: true, Message: JSON.stringify(err.response.data.errors), severity: severitys.error });
            }
            else if (err.message) {
                setOpen({ IsEnable: true, Message: JSON.stringify(err.message), severity: severitys.error });
            }

        })
            .finally(() => {
                setIsLoading(false);
                ResetForm();
            });
    }
    const HandleAddGuestToFlight = (flightId, data) => {
        setIsLoading(true);
        brokerGroupApi.AddGuestToFlight(flightId, data).then(res => {

            if (res.data?.success) {
                setOpen({ IsEnable: true, Message: 'مسافر میهمان به پرواز مورد نظر افزوده شد', severity: severitys.success });

            }
            else {
                setOpen({ IsEnable: true, Message: res.data.message ? res.data.message : 'خطا در عملیات', severity: severitys.error });
            }

        }).catch(err => {

            if (err.response && err.response.data) {
                setOpen({ IsEnable: true, Message: JSON.stringify(err.response.data), severity: severitys.error });
            }
            else if (err.response && err.response.data && err.response.data.errors) {
                setOpen({ IsEnable: true, Message: JSON.stringify(err.response.data.errors), severity: severitys.error });
            }
            else if (err.message) {
                setOpen({ IsEnable: true, Message: JSON.stringify(err.message), severity: severitys.error });
            }

        }).finally(() => {
            setIsLoading(false);
            ResetForm();
        });

    }
    const handleAssignPassenger = () => {
        if (!selectedPassenger) {
            setRequiredError(true);
        }
        else {

            addPassengerToFlight(row.flightId, selectedPassenger);

        }
    }
    const handleAddEditGuest = (data) => {
        let ssn = null;
        if (watch("ssn"))
            ssn = watch("ssn");
        let passNO = null;
        if (watch("passNO"))
            passNO = watch("passNO");
        let name = null;
        if (watch("name"))
            name = watch("name");
        let family = null;
        if (watch("family"))
            family = watch("family");
        let fatherName = null;
        if (watch("fatherName"))
            fatherName = watch("fatherName");
        let guestTypeId = null;
        if (watch("guestTypeId"))
            guestTypeId = parseInt(watch("guestTypeId"));
        let birthdateGregorian = null;
        if (data.birthDate) {
            let birthD = new DateObject({
                date: data.birthDate,
                calendar: persian,
                locale: persian_fa
            });

            var birthdateStr = birthD.year + '/' + birthD.month.number + '/' + birthD.day;
            birthdateGregorian = moment.from(birthdateStr, 'fa', 'YYYY/MM/DD').format('YYYY-MM-DD')
        }
        const guestData = {
            "guestType": guestTypeId,
            "name": name,
            "family": family,
            "fatherName": fatherName,
            "ssn": ssn,
            "passNO": passNO,
            "mBirthDate": birthdateGregorian
        }
        if (selectedGuestId !== null) {
            HandleEditGuestFlight(selectedGuestId, guestData);
        }
        else {
            HandleAddGuestToFlight(row.flightId, guestData);
        }

    }

    const fillGuestTypeDropDown = () => {
        staticVariablesApi.GetGuestTypeDropDown().then((res) => {
            const arr = helper.DictionayToList(res.data.data);
            setGuestType(arr.map((o) => {
                return {
                    id: o.key,
                    label: o.value
                };
            }));
        })
            .catch((error1) => {
                console.log(error1);
            })

    }
    const getFlightGuests = () => {
        setIsLoading(true)
        brokerGroupApi.GetFlightGuestsByFlightId(row.flightId).then(res => {
            if (res.status === 200) {
                setFlightGuests(res.data.data);
            }
            else {
                setOpen({ IsEnable: true, Message: res.data.message ? res.data.message : 'خطا در دریافت لیست مسافران میهمان', severity: severitys.error });
            }
        }).catch(err => {

            if (err.status === 401) {
                localStorage.clear();
                window.location.pathname = "/login";
            }
            if (err.response && err.response.data) {
                setOpen({ IsEnable: true, Message: JSON.stringify(err.response.data), severity: severitys.error });
            }
            else if (err.response && err.response.data && err.response.data.errors) {
                setOpen({ IsEnable: true, Message: JSON.stringify(err.response.data.errors), severity: severitys.error });
            }
            else if (err.message) {
                setOpen({ IsEnable: true, Message: JSON.stringify(err.message), severity: severitys.error });
            }

        }).finally(() => { setIsLoading(false) });


    }
    const ResetAddGuestInputs = () => {
        setValue("passNO", null);
        setValue("ssn", null);
        setValue("name", null);
        setValue("family", null);
        setValue("fatherName", null);
        setValue("birthDate", null);
        setValue("guestTypeId", null);
        fillGuestTypeDropDown();
        setSelectedGuestId(null);
        getFlightGuests();
    }
    const ResetAddPassengerInputs = () => {
        setRequiredError(false);
        setValue("Searchssn", null)
        setSelectedPassenger(null);
        setPassengers([]);
    }
    const ResetForm = () => {
        setIsLoading(false);
        //  setShowAddGuest(false);
        ResetAddPassengerInputs();
        ResetAddGuestInputs();

    }
    ////////Edit/////////////////////////
    const clearGuestData = () => {

        setValue("passNO", null);
        setValue("ssn", null);
        setValue("name", null);
        setValue("family", null);
        setValue("fatherName", null);
        setValue("birthDate", null);
        setValue("guestTypeId", null);
    }
    const resetGuestData = (data) => {
        setValue("passNO", data.passNO);
        setValue("ssn", data.ssn);
        setValue("name", data.name);
        setValue("family", data.family);
        setValue("fatherName", data.fatherName);
        setValue("birthDate", data.persionMBirthDate);
        setValue("guestTypeId", String(data.guestType));

    }
    const [selectedGuestId, setSelectedGuestId] = useState(null);
    const handleOpenEdit = (data) => {
        if (selectedGuestId === data.id) {
            setSelectedGuestId(null);
            clearGuestData();

        }
        else {
            setSelectedGuestId(data.id)
            resetGuestData(data);
        }
    }
    //////delete 
    const [openDeleteGuest, setOpenDeleteGuest] = useState(false);
    const [deleteData, setDeleteData] = useState(null);
    const handleOpenDelete = (data) => {
        setOpenDeleteGuest(true);
        setDeleteData(data);
    };
    const handlecloseDelete = () => {
        setOpenDeleteGuest(false);
        setDeleteData(null);
    }
    const DeleteGuest = () => {
        setIsLoading(true)
        brokerGroupApi.deleteFlightGuest(deleteData.id).then(res => {
            if (res.status === 200) {
                if (res.data.success) {
                    setOpen({ IsEnable: true, Message: 'مسافر مورد نظر با موفقیت حذف شد', severity: severitys.success });
                    handlecloseDelete();
                }
                else {
                    setOpen({ IsEnable: true, Message: res.data.message ? res.data.message : 'خطا در عملیات', severity: severitys.error });
                }
            }
            else {
                setOpen({ IsEnable: true, Message: res.data.message ? res.data.message : 'خطا در حذف مسافر', severity: severitys.error });
            }
        }).catch(err => {

            if (err.status === 401) {
                localStorage.clear();
                window.location.pathname = "/login";
            }
            if (err.response && err.response.data) {
                setOpen({ IsEnable: true, Message: ' خطا در عملیات: ' + JSON.stringify(err.response.data), severity: severitys.error });
            }
            else if (err.response && err.response.data && err.response.data.errors) {
                setOpen({ IsEnable: true, Message: JSON.stringify(err.response.data.errors), severity: severitys.error });
            }
            else if (err.message) {
                setOpen({ IsEnable: true, Message: JSON.stringify(err.message), severity: severitys.error });
            }

        }).finally(() => {
            setIsLoading(false);
            ResetForm();
        });
    }

    return (
        <div >
            <RtlProvider>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <Grid container spacing={1} >
                        <Grid item md={12} xs={12}>
                            <Button onClick={() => { setShowAddGuest(false); }} >

                                <Typography variant="h4" color="primary" sx={{ display: "flex", alignItems: "center" }}>
                                    <Avatar sx={{ bgcolor: "#d0c6d1ff", color: "secondary", mr: 1 }}>
                                        <FaUserPlus size={20} />
                                    </Avatar>
                                    افزودن مسافر به پرواز
                                </Typography></Button>
                        </Grid>
                        {(showAddGuest == false) && <Grid container spacing={1} >
                            <Grid item md={12} xs={12} >
                                <Typography variant="h5" gutterBottom component="div" style={{ textAlign: "right" }} sx={{ ml: 2 }}>
                                    {'مسافر اضافه شده به پرواز را انتخاب نمایید:'}
                                </Typography>
                            </Grid>
                            <Grid item md={12} xs={12} sx={{ ml: 2 }}>
                                <TextField margin="normal" autoFocus variant="outlined" {...register("Searchssn")} label=" کدملی ">
                                </TextField>

                                <Button sx={{ width: 100, mt: 3, ml: 1 }} variant="contained" color="primary" onClick={() => { SearchPassenger() }}  >
                                    <BeatLoading loading={isLoading} color={"#e65100"} />
                                    جستجو
                                </Button>
                            </Grid>


                            {(passengers?.length > 0) &&
                                <Grid itm md={5} xs={12}>

                                    <Box sx={{

                                        ml: 3,
                                        mt: 1,
                                        mb: 1,
                                        display: "flex",
                                        flexDirection: "column",
                                        maxHeight: 500,
                                        overflowY: "scroll",
                                    }} >
                                        <RHFRadioGroup
                                            control={control}
                                            name="FlightHourTypeId"
                                            onChange={handleChangeRadioGroup}
                                            options={passengers}

                                        />
                                    </Box>
                                    {(requiredError) && <p className="error">{'یک نفر راانتخاب کنید.'}</p>}
                                </Grid>}
                            <Grid container  >
                                <Grid item md={9} xs={7}></Grid>
                                <Grid item md={2} xs={4}>

                                    <Button sx={{ m: 1, mr: 1, width: 120 }} variant="contained" disabled={(isLoading)} onClick={() => { handleAssignPassenger(); }} color="primary" fullWidth >
                                        <BeatLoading loading={isLoading} color={"#e65100"} /> {'تائید و ثبت'}  </Button>

                                </Grid>
                            </Grid>
                        </Grid>}

                        <Grid item md={12} xs={12}>
                            <Button onClick={() => { setShowAddGuest((old) => (!old)) }} >
                                <Typography variant="h4" color="primary" sx={{ display: "flex", alignItems: "center" }}>
                                    <Avatar sx={{ bgcolor: "#d0c6d1ff", color: "secondary", mr: 1 }}>
                                        <FaUserPlus size={20} />
                                    </Avatar>
                                    افزودن میهمان به پرواز
                                </Typography></Button>
                        </Grid>
                        {(showAddGuest == true) && <Grid container spacing={1} sx={{ ml: 1 }}  >
                            <Grid item md={3} xs={4}>
                                <RHFAutocomplete
                                    focused={selectedGuestId !== null}
                                    control={control}
                                    options={guestType ?? []}
                                    name="guestTypeId"
                                    placeholder="نوع میهمان"
                                    style={{
                                        border: "none",
                                        padding: 0
                                    }}
                                />
                                <p className="error">{errors.guestTypeId?.message}</p>
                            </Grid>
                            <Grid item md={3} xs={4} >
                                <TextField focused={selectedGuestId !== null} variant="outlined" {...register("passNO")} label="شماره گذرنامه" fullWidth />
                                <p className="error">{errors.passNO?.message}</p>
                            </Grid>
                            <Grid item md={3} xs={4}>
                                <TextField focused={selectedGuestId !== null} variant="outlined" {...register("ssn")} label=" کدملی " fullWidth>
                                </TextField>
                                <p className="error">{errors.ssn?.message}</p>
                            </Grid>
                            <Grid item md={3} xs={4}>
                                <TextField focused={selectedGuestId !== null} variant="outlined" {...register("name")} label=" نام " fullWidth></TextField>
                                <p className="error">{errors.name?.message}</p>
                            </Grid>
                            <Grid item md={3} xs={4}>
                                <TextField focused={selectedGuestId !== null} variant="outlined" {...register("family")} label=" نام خانوادگی " fullWidth></TextField>
                                <p className="error">{errors.family?.message}</p>
                            </Grid>
                            <Grid item md={3} xs={4}>
                                <TextField focused={selectedGuestId !== null} variant="outlined" {...register("fatherName")} label=" نام پدر " fullWidth></TextField>
                                <p className="error">{errors.fatherName?.message}</p>
                            </Grid>
                            <Grid item md={3} xs={4} >
                                <Controller
                                    focused={selectedGuestId !== null}
                                    control={control}
                                    name="birthDate"
                                    rules={{ required: true }}
                                    render={({
                                        field: { onChange, name, value },
                                        fieldState: { invalid, isDirty },
                                    }) => (
                                        <>
                                            <DatePicker
                                                value={value || ""}
                                                onChange={(date) => {
                                                    onChange(date?.isValid ? date : "");

                                                }}
                                                format={"YYYY/MM/DD"}
                                                calendar={persian}
                                                locale={persian_fa}
                                                calendarPosition="bottom-right"
                                                render={<CustomDateInput label={" تاریخ تولد"} />}
                                            />

                                        </>
                                    )}
                                />
                                <p className="error">{errors.birthDate?.message}</p>
                            </Grid>


                            <Grid container  >
                                <Grid item md={9} xs={7}></Grid>
                                <Grid item md={2} xs={4}>

                                    <Button type="submit" sx={{ m: 1, mr: 1, width: 120 }} variant="contained" disabled={(isLoading)} color="primary" fullWidth >
                                        <BeatLoading loading={isLoading} color={"#e65100"} /> {(selectedGuestId !== null) ? 'ویرایش' : 'تائید و ثبت'}  </Button>

                                </Grid>
                            </Grid>
                        </Grid>}


                        {(showAddGuest === true) && (flightGuests?.length > 0) && <Box sx={
                            {
                                m: 3,
                                alignItems: "center",
                                maxHeight: 200,
                                overflowY: "scroll"
                            }}>

                            <Paper sx={{
                                width: "100%", display: "flex",
                                flexDirection: "column",
                                maxWidth: 610,
                                overflowX: "scroll",

                            }}>
                                <DataGrid
                                    rows={flightGuests}
                                    columns={Columns}
                                    initialState={{
                                        pagination: {
                                            paginationModel: {
                                                pageSize: 50,
                                            },
                                        },
                                    }}
                                    pageSizeOptions={[25, 50, 100]}
                                    checkboxSelection={false}
                                    disableRowSelectionOnClick
                                    disableColumnMenu
                                    disableColumnSelector
                                    loading={isLoading}
                                    sx={{
                                        backgroundColor: '#F1F1E8', // Set your desired background color    
                                        '& .MuiDataGrid-columnHeaders > div[role="row"]': {
                                            color: '#F1F1E8!important',
                                            backgroundColor: '#50a193ff!important',
                                        },
                                    }}
                                />
                            </Paper >

                            <ConfirmationDialog
                                open={openDeleteGuest}
                                handleClose={handlecloseDelete}
                                deleteFunction={DeleteGuest}
                            />
                        </Box>}
                    </Grid>
                </form>
            </RtlProvider>
        </div>

    );

}
export default AddPassengerToFlight;
